import { z } from "zod";
import { BigNumber } from "bignumber.js";
export const BigNumberSchema = z.custom((val) => val instanceof BigNumber, {
    message: "Expected BigNumber instance",
});
export const BigNumberCodec = z.codec(z.string(), BigNumberSchema, {
    encode: (bigNumber) => bigNumber.toString(10),
    decode: (str) => new BigNumber(str),
});
//# sourceMappingURL=BigNumber.js.map